import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { drawerWidth } from 'store/appConstant';
import { Link } from 'react-router-dom';

const Footer = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.secondary[800],
                textAlign: 'center',
                padding: '10px 0',
                position: 'fixed',
                bottom: 0,
                left: 0,
                zIndex: 2000,
            }}
        >
            <Grid container>
                {/* First Grid: Set width to drawerWidth */}
                <Grid item sx={{ width: drawerWidth, display: { xs: 'none', md: 'flex' }, alignItems: 'center', justifyContent: 'center' }}>
                    <Typography sx={{ fontSize: { xs: '8px', md: '12px' }, textAlign: 'center' }}>
                        2025 ©Uniprevoyance
                    </Typography>
                </Grid>

                {/* Second Grid: Use flexGrow to take remaining space */}
                <Grid item sx={{flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography sx={{
                        fontSize: {xs: '8px', md: '12px'},
                        textAlign: 'center',
                        display: {xs: 'flex', md: 'none'},
                        marginRight: {xs: '0px', md: '20px'},
                        paddingLeft: '10px'
                    }}>
                        2025 ©Uniprevoyance
                    </Typography>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography
                            component={Link}
                            to="/ui/informations-legales-unip"
                            sx={{
                                fontSize: {xs: '8px', md: '12px'},
                                textDecoration: 'underline',
                                textAlign: 'left',
                                paddingLeft: '10px',
                                color: 'inherit', // Keep the text color consistent
                                '&:hover': { // Change color on hover
                                    color: '#48BECD'
                                }
                            }}
                        >
                            Informations Légales
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: {xs: '8px', md: '12px'},
                                textDecoration: 'underline',
                                textAlign: 'left',
                                paddingLeft: '10px'
                            }}>
                            {/* Autres Informations */}
                        </Typography>
                    </Box>
                    <a href="https://www.uniprevoyance.fr/" target="_blank" rel="noopener noreferrer">
                        <img
                            src={`${process.env.PUBLIC_URL}/assets/img/calque-1.svg`}
                            alt="Logo"
                            style={{height: '28px', marginRight: '20px'}} // Adjust margin as needed
                        />
                    </a>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Footer;
